import config from '../config';

/** image_url may be relative (/api/images/<id>/): resolve it against the API base. */
export function resolveImage(src) {
  if (!src || /^(https?:|data:|blob:)/.test(src)) return src;
  const base = (config.apiUrl || '/').replace(/\/$/, '');
  return src.startsWith('/') ? `${base}${src}` : src;
}
